import { useRef } from "react";
import useFade from "../../../MainComponents/Hooks/useFade";

import HelmetTags from "../../../MainComponents/HelmetTags";
import useAxios from "../../../MainComponents/Hooks/useAxios";
import Loader from "../../../MainComponents/Loader";
import SingleCourseCode from "../../../MainComponents/SingleCourseCode.jsx";

function StudentCourses() {
  //!---- get all courses  -------

  const [allCoursesData, allCoursesErrors, allCoursesLoading] = useAxios(
    process.env.REACT_APP_COURSES_API,
    "GET",
    "GET"
  );

  const TitleWrapper = useRef();
  const [fade] = useFade(TitleWrapper, 100);

  if (allCoursesLoading) {
    return <Loader />;
  }
  if (allCoursesErrors) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <p>{allCoursesErrors}</p>;
      </div>
    );
  }

  return (
    <section className=" width  mb-32 h-full  dark:bg-dark dark:text-light">
      <HelmetTags title="الكورسات | مسيو بلال عبدالله "></HelmetTags>{" "}
      <div ref={TitleWrapper} className="title-wrapper  mt-36">
        <h2
          className={`mb-32 text-center text-5xl font-bold transition-all duration-300 ease-linear ${
            fade ? "translate-y-14 opacity-0" : "translate-y-0 opacity-100"
          } `}
        >
          أفضل الكورسات{" "}
        </h2>
      </div>
      <div className="courses grid-auto-fit">
        {allCoursesData?.data?.length === 0 ? (
          <p>لا يوجد كورسات</p>
        ) : (
          allCoursesData?.data?.map((card) => (
            <SingleCourseCode courseCode={card} key={card.key} />
          ))
        )}
      </div>
    </section>
  );
}

export default StudentCourses;
